import { createReducer, on } from "@ngrx/store";
import * as PupilDuplicateActions from './pupil-duplicate.actions';
import { initialPupilDuplicateState } from "./pupil-duplicate.state";

export const pupilDuplicateReducer = createReducer(
  initialPupilDuplicateState,

  // LOAD
  on(PupilDuplicateActions.loadPupilDuplicates, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PupilDuplicateActions.loadPupilDuplicatesSuccess, (state, { groups }) => ({
    ...state,
    loading: false,
    loaded: true,
    groups,
  })),
  on(PupilDuplicateActions.loadPupilDuplicatesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  // DISMISS: the group leaves the list on success.
  on(PupilDuplicateActions.dismissPupilDuplicate, (state, { groupId }) => ({
    ...state,
    actionInProgressId: groupId,
  })),
  on(PupilDuplicateActions.dismissPupilDuplicateSuccess, (state, { groupId }) => ({
    ...state,
    actionInProgressId: null,
    groups: state.groups.filter((group) => group.id !== groupId),
  })),
  // Shown in a snackbar by the page, so it does not set the persistent error banner.
  on(PupilDuplicateActions.dismissPupilDuplicateFailure, (state) => ({
    ...state,
    actionInProgressId: null,
  })),

  // REMOVE COPIES: the removed pupils leave the group; a group down to one pupil is no longer a duplicate.
  on(PupilDuplicateActions.removePupilDuplicateMembers, (state, { groupId }) => ({
    ...state,
    actionInProgressId: groupId,
  })),
  on(PupilDuplicateActions.removePupilDuplicateMembersSuccess, (state, { groupId, accountIds }) => ({
    ...state,
    actionInProgressId: null,
    groups: state.groups
      .map((group) => group.id !== groupId ? group : {
        ...group,
        members: group.members.filter((member) => !accountIds.includes(member.accountId)),
      })
      .filter((group) => group.members.length > 1),
  })),
  on(PupilDuplicateActions.removePupilDuplicateMembersFailure, (state) => ({
    ...state,
    actionInProgressId: null,
  }))
);
